import { NgModule } from '@angular/core';
import { ToastService } from './toast.service';

@NgModule({
  providers: [
    ToastService
  ]
})
export class ToastModule { }
